<template>
  <div class="pop">
    <div class="back">
      <img :src="back" alt="" @click="handleClose">
      <div class="title">{{ $t('lang.usdt.how') }}</div>
    </div>
    <div class="howContent">
      <div class="itemBox" v-for="(item,index) in $t('lang.usdt.howContents')" :key="index">
        <div class="title">{{item.title}}</div>
        <div class="content" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import back from '@/assets/images/common/back.svg'
export default {
  name: 'howToUseUSDTPop',
  data () {
    return {
      back
    }
  },
  mounted () {},
  methods: {
    handleClose () {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="less" scoped>
.pop {
  position: fixed;
  top: 56px;
  width: 100vw;
  height: calc(100vh - 56px);
  overflow: hidden;
  z-index: 10;
  background-color: #161616;
  padding-bottom: calc(5vw + 70px);
  .back {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 8px;
    padding: 0 16px;

    .title {
      font-size: 18px;
      line-height: 30px;
      color: #F6D9AA;
      font-weight: bold;
      margin-left: 15px;
    }

    img {
      width: 30px;
      height: 30px;
    }
  }
  .howContent {
    display:  flex;
    flex-direction: column;
    align-items: center;
    gap: 5vw;
    padding-top: 6.638vw;

    .itemBox {
      display:  flex;
      flex-direction: column;
      gap: 1.111vw;
      .title {
        color: #FFFFFF;
        font-size: 4.166vw;
        font-weight: 600;
      }
      .content {
        color: #B0A7A7;
        font-size: 3.888vw;
        font-weight: 500;
        width: 89.247vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/howToUseUSDTPop/index.vue